export default {"src":"/_next/static/media/baby6.2dbf63de.svg","height":210,"width":210,"blurWidth":0,"blurHeight":0};